import { useSelector, shallowEqual } from 'react-redux';
import { select, __get } from '../utils';

/**
 * هوک کاستم که همراه شلو ایکوال است و بجای یوزسلکتور عادی ری اکت ریداکس از آن استفاده میکنیم.
 * @param selector - سلکتور استیت
 * @example <caption>برای مثال سلکت کردن استیت اسلایس تکی و یکجا</caption>
 * const slice = useSelector(state=> state.slice);
 * const { slice1, slice2 } = useSelector(state=> ({ slice1: state.slice1, slice2: state.slice2 }));
 * @example <caption>کد  بالا بصورت زیر قابل بازنویسی است:</caption>
 * const slice = useSelector("slice");
 * const [slice1, slice2] = useSelector(["slice1", "slice2"]);
 */

export const useShallowEqualSelector = (selector, fallback) =>
  useSelector(
    typeof selector === 'string'
      ? select(selector)
      : Array.isArray(selector)
      ? (state) =>
          selector.reduce((acc, cv, key) => {
            acc.push(__get(state, cv));
            return acc;
          }, [])
      : selector,
    shallowEqual
  ) || fallback;
